import i18n from './i18n'

import { Config } from '#/global/helper/Config'

export const getLocale = () => {
    const t = i18n[Config.getLang()]
    return {
        localize: {
            day: (n: number) => t.days[n],
            month: (n: number) => t.months[n],
        },
        formatLong: {
            date: () => 'dd.MM.yyyy',
            time: () => 'HH:mm',
            dateTime: () => 'dd.MM.yyyy HH:mm',
        },
    }
}
